import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceTaxTable extends Layout {
    sourceExcisetaxMiscBill: DataSource;
    tableExciseTaxes: Table;
}
